import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

//PAGES
import { PedidoPage } from '../pedido/pedido';

//PROVIDERS
import { Services, Tools } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-janela',
  templateUrl: 'janela.html',
})
export class JanelaPage {
  pedidos:any;
  textButton:string='Iniciar Próxima Entrega';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private services: Services,
    private tools: Tools
  ){
    this.pedidos = this.navParams.get('item');
  }

  ionViewDidLoad(){}

  openPedido(pedido:any){
    this.navCtrl.push(PedidoPage,{item:pedido});
  }

  openWaze(){
    let pedido = this.pedidos.find(e=>['Em Andamento','Aguardando Entrega'].indexOf(e.entregas.status)>=0);

    if(!pedido){
      alert('Nenhum pedido pendente.');
      return;
    }

    if(pedido.entregas.status == 'Aguardando Entrega'){
      pedido.entregas.status = 'Em Andamento';
      window.open('geo:'+pedido.position.lat+','+pedido.position.lng, '_system');
    }else{
      pedido.entregas.status = 'Finalizado';
    }

    this.services.save('cadPedidos',pedido,(result)=>{
      console.log('OK');
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/janela/janela.ts